module.exports = __webpack_public_path__ + "img/step47_a_printer_basic_remove_tapes.46018c21.png";